// ProgressBar — the determinate progress primitive (DESIGN_LANGUAGE.md §9).
// Pass `value` as 0..1. Track is the `overlay` wash; fill is ink (`title`),
// pill-rounded. The width transition is the language's one sanctioned
// layout animation — a determinate indicator must resize to mean anything.
//
//   Uploading: { extends: 'ProgressBar', value: (el, s) => s.uploadProgress }
//
// `warnAt` / `dangerAt` (0..1, optional) — a limit-style consumer (a
// balance approaching its cap) should "change character as it approaches
// the limit" (DESIGN_LANGUAGE §4.2 status roles), not stay ink until a
// bare 100%. When set, the fill steps ink → `yellow` → `red` as `value`
// crosses each threshold. Unset by default so every existing consumer
// (plain upload/determinate progress) keeps its current plain-ink fill —
// additive only, per the D5 change-set convention.
//
//   CreditsUsed: { extends: 'ProgressBar', value: 0.92, warnAt: 0.7, dangerAt: 0.9 }
export const ProgressBar = {
  width: '100%',
  height: 'X',
  round: 'radiusPill',
  background: 'overlay',
  overflow: 'hidden',
  value: 0,
  warnAt: null,
  dangerAt: null,
  role: 'progressbar',
  'aria-valuemin': '0',
  'aria-valuemax': '100',
  'aria-valuenow': (el) => String(Math.round(Math.min(1, Math.max(0, el.value || 0)) * 100)),

  Fill: {
    height: '100%',
    round: 'radiusPill',
    background: (el) => {
      const parent = el.parent
      const v = Math.min(1, Math.max(0, parent?.value || 0))
      if (parent?.dangerAt != null && v >= parent.dangerAt) return 'red'
      if (parent?.warnAt != null && v >= parent.warnAt) return 'yellow'
      return 'title'
    },
    transition: 'width B defaultBezier, background A defaultBezier',
    width: (el) => `${Math.min(100, Math.max(0, (el.parent?.value || 0) * 100))}%`
  }
}
